import React from 'react';
import Typography from '../../basic/Typography';
import { Button } from '../../basic/Button';
import { ProductCardContent } from '../../../content/types';
import { ReactComponent as VMonadLogo } from '../../../assets/vmonad-logo.svg';
import { ReactComponent as ArcLogo } from '../../../assets/arc-logo.svg';
import { ReactComponent as DeepVisionLogo } from '../../../assets/deepvision-logo.svg';
import { ReactComponent as KhzLogo } from '../../../assets/khz-logo.svg';
import './styles.css';

interface ProductCardProps {
  content: ProductCardContent;
}

export const ProductCard: React.FC<ProductCardProps> = ({ content }) => {
  const hasAnimatedImage = Boolean(content.imageAnimated);

  const renderLogo = () => {
    if (hasAnimatedImage) {
      return (
        <img
          src={content.imageAnimated}
          alt={content.name + ' animation'}
          className="product-card-animated-img"
          draggable="false"
        />
      );
    }
    if (content.svgLogo === 'arc') {
      return <ArcLogo className="product-card-svg-logo" />;
    }
    if (content.svgLogo === 'deepvision') {
      return <DeepVisionLogo className="product-card-svg-logo" />;
    }
    if (content.svgLogo === 'khz') {
      return <KhzLogo className="product-card-svg-logo" />;
    }
    if (content.useSvgLogo) {
      return <VMonadLogo className="product-card-svg-logo" />;
    }
    return content.unicodeLogo;
  };

  return (
    <div className="product-card" tabIndex={0}>
      <div className="product-card-header">
        {renderLogo()}
        <Typography
          variant="h1"
        >
          {content.name}
        </Typography>
      </div>
      <div className="product-card-description">
        <Typography
          variant="h2"
        >
          {content.description}
        </Typography>
      </div>
      <Button
        variant="outlined"
        color="secondary"
        href={content.ctaHref}
        className="product-card-cta apple-style-button"
      >
        {content.ctaText}
      </Button>
    </div>
  );
};

export default ProductCard;